



























import { Component, Vue } from "vue-property-decorator";

@Component
class RouteInfoV2RouteTableHeader extends Vue {}
export default RouteInfoV2RouteTableHeader;
